import React, { useEffect, useState } from "react";
import api from "../Utils/api";
import { RefreshCw, Plus, Search, Edit2, Trash2 } from "lucide-react";
import AddTaskModal from "../Components/Task/AddTaskModal"; // Reuse for add/edit
import LocationWithMap from "../Components/Task/LocationWithMap";
import Select from "react-select";
import DatePicker from "../Components/Feed/DatePicker";
import { useSelector } from "react-redux";
import Spinner from "../Components/Spinner";

export default function TasksPage() {
  const user = useSelector((state) => state.user.user);
  const [openTaskModal, setOpenTaskModal] = useState(false);
  const [openMapDialog, setOpenMapDialog] = useState(false);
  const [taskList, setTaskList] = useState([]);
  const [myTaskList, setMyTaskList] = useState([]);
  const [numMyInComplete, setNumMyInComplete] = useState(0);
  const [myAsignedTaskList, setMyAssignedTaskList] = useState([]);
  const [numAssignInComplete, setNumAssignInComplete] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [editingTask, setEditingTask] = useState(null); // null = add mode, task object = edit mode
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  // Get the current date
  const currentDate = new Date();

  // Get the start of the current day (00:00)
  const startOfDay = new Date(currentDate);
  startOfDay.setUTCHours(0, 0, 0, 0); // Set to 00:00:00.000

  const formatDateValue = (date) => {
    return (
      date.getFullYear() +
      "-" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(date.getDate()).padStart(2, "0")
    );
    // String(date.getHours()).padStart(2, '0') + ":" +
    // String(date.getMinutes()).padStart(2, '0') + ":" +
    // String(date.getSeconds()).padStart(2, '0');
  };

  useEffect(() => {
    getTaskList();
    getLocations();
  }, [user]);

  const getTaskList = async () => {
    try {
      setIsLoading(true);
      const res = await api.get("/task");
      setIsLoading(false);
      if (res.data.success) {
        setTaskList(res.data.tasks);
        const taskData = res.data.tasks;
        setFilteredTasks(taskData);

        const mydata = taskData.filter(
          (task) => task.assignTo && user && task.assignTo._id == user._id
        );
        setMyTaskList(mydata); // Tasks assigned TO me
        const completedTasks = mydata.filter(
          (task) => task.completed === false
        );
        setNumMyInComplete(completedTasks.length);

        const myassigneddata = taskData.filter(
          (task) =>
            task.assignTo &&
            user &&
            task.userID._id === user._id &&
            task.assignTo._id !== user._id
        );
        setMyAssignedTaskList(myassigneddata); // Tasks I created but assigned to others
        const completedAssignedTasks = myassigneddata.filter(
          (task) => task.completed === false
        );
        setNumAssignInComplete(completedAssignedTasks.length);
      }
    } catch (error) {
      console.error("Failed to fetch tasks:", error);
    }
  };

  useEffect(() => {
    const completedTasks = myTaskList.filter(
      (task) => task.completed === false
    );
    setNumMyInComplete(completedTasks.length);
    const completedAssignedTasks = myAsignedTaskList.filter(
      (task) => task.completed === false
    );
    setNumAssignInComplete(completedAssignedTasks.length);
  }, [myTaskList, myAsignedTaskList]);

  useEffect(() => {
    handleChangeLocation();
  }, [selectedLocation]);

  const getLocations = async () => {
    try {
      const response = await api.get("/location");
      setLocations(response.data.locations);
    } catch (error) {
      console.error(error);
    }
  };

  // Open modal for adding new task
  const handleAddTask = () => {
    setEditingTask(null);
    setOpenTaskModal(true);
  };

  // Open modal for editing existing task
  const handleEditTask = (task) => {
    setEditingTask(task);
    setOpenTaskModal(true);
  };

  // Delete task with confirmation
  const handleDeleteTask = async (taskId) => {
    if (!window.confirm("Are you sure you want to delete this task?")) return;

    try {
      await api.delete(`/task/${taskId}`);
      // Refresh task list after deletion
      getTaskList();
    } catch (error) {
      console.error("Failed to delete task:", error);
      alert("Failed to delete task. Please try again.");
    }
  };

  // Callback after add/edit modal closes and task saved
  const handleModalClose = (refresh = false) => {
    setOpenTaskModal(false);
    setEditingTask(null);
    if (refresh) {
      getTaskList();
    }
  };

  // Filter tasks by search term (title, notes, preferredName)
  // const [filteredTasks, setFilteredTasks] = useState([]);
  // const filteredTasksData = taskList.filter((task) => {
  //   const search = searchTerm.toLowerCase();
  //   return (
  //     task.title.toLowerCase().includes(search) ||
  //     (task.notes && task.notes.toLowerCase().includes(search)) ||
  //     (task.assignTo?.preferredName?.toLowerCase().includes(search) ?? false)
  //   );
  // });

  const [filteredTasks, setFilteredTasks] = useState(taskList);

  const handleTaskSearch = () => {
    const filteredTasksData = taskList.filter((task) => {
      const search = searchTerm.toLowerCase();
      return (
        task.title.toLowerCase().includes(search) ||
        (task.notes && task.notes.toLowerCase().includes(search)) ||
        (task.assignTo?.preferredName?.toLowerCase().includes(search) ?? false)
      );
    });
    setFilteredTasks(filteredTasksData);
  };

  const handleChangeLocation = () => {
    const filteredTasksData = taskList.filter(
      (task) =>
        task.userID.locations?.primaryLocation?._id == selectedLocation?._id
    );
    setFilteredTasks(filteredTasksData);
  };

  const handleTaskKeyDown = (e) => {
    if (e.key === "Enter") {
      handleTaskSearch();
    }
  };

  // Format date nicely
  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateStr).toLocaleDateString(undefined, options);
  };

  const changeLocation = (option) => {
    // //console.log(option,'options');
    setSelectedLocation(option);
    if (option) {
    } else {
      setTaskList();
    }
  };

  const beginTimeFromChild = (data) => {
    // console.log(data);
    const filteredTasksData = taskList.filter((task) => {
      const search = data.toLowerCase();
      return task.dueDate.toLowerCase().includes(search);
    });
    setFilteredTasks(filteredTasksData);
  };

  const handleMyTask = () => {
    setFilteredTasks(myTaskList);
  };

  const handleAssignedMyTask = () => {
    setFilteredTasks(myAsignedTaskList);
  };

  return (
    <div className="px-6 mt-20 mx-20">
      {isLoading && <Spinner />}

      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Tasks</h1>
        <button
          onClick={handleAddTask}
          className="bg-gray-200 text-gray-600 px-4 py-2 rounded-md flex items-center gap-1"
        >
          <Plus size={16} />
          Add task
        </button>
      </div>
      {/* ---------------------Search part------------------------- */}
      <div className="flex flex-wrap gap-4 items-center justify-between mb-6">
        <div>
          <div className="min-w-full !min-h-[55px] flex justify-start items-start pl-2">
            <ul className="flex items-center justify-center space-x-2 font-[sans-serif] mt-2">
              <li
                className={`w-[300px] text-gray-500 bg-[transparent] text-sm tracking-wide flex items-center rounded  ${
                  true
                    ? "cursor-pointer hover:!border-[#265c7f] bg-[transparent]"
                    : "cursor-not-allowed bg-[#f5f5f5]"
                } `}
              >
                <Select
                  name="devicelist"
                  placeholder={"Select a Location"}
                  className={`basic-multi-select w-full cursor-pointer !m-0 !p-0`}
                  classNamePrefix="select"
                  options={locations}
                  value={selectedLocation}
                  onChange={changeLocation}
                  getOptionLabel={(option) => option.name} // Show only the label
                  getOptionValue={(option) => option._id}
                  // isClearable={true}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      borderColor: "gray", // Change border color based on focus state
                      boxShadow: "none", // Remove default shadow
                      "&:hover": {
                        borderColor: "gray", // Change border color on hover
                      },
                    }),
                  }}
                />
              </li>
              <li
                className={`w-[180px] text-gray-500 bg-[transparent] text-sm tracking-wide flex items-center rounded  ${
                  true
                    ? "cursor-pointer hover:!border-gray-200 bg-[transparent]"
                    : "cursor-not-allowed bg-gray-100"
                } `}
              >
                <DatePicker
                  onSendData={beginTimeFromChild}
                  initialValue={new Date(formatDateValue(startOfDay))}
                  placeLetter={"Start Date Time"}
                  enabled={true}
                />
              </li>
              <li
                className={` bg-[transparent] px-3 py-2 text-sm tracking-wide flex items-center border border-gray-500 rounded  ${
                  true
                    ? "cursor-pointer hover:!border-gray-300 bg-[transparent]"
                    : "cursor-not-allowed bg-gray-200"
                } `}
                onClick={() => getTaskList()}
              >
                <svg
                  className="w-4 h-4"
                  focusable="false"
                  aria-hidden="true"
                  viewBox="0 0 24 24"
                  data-testid="RefreshIcon"
                  title="Refresh"
                  fill="gray"
                >
                  <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z"></path>
                </svg>
                <span className="!text-gray-600">Reload</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="relative">
          <input
            type="text"
            placeholder="Search"
            className="w-full sm:w-80 border border-gray-300 rounded-md py-2 px-4 pl-10 focus:outline-none focus:ring-1 focus:ring-gray-200"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={handleTaskKeyDown}
          />
          <Search className="absolute left-3 top-2.5 text-gray-500" size={16} />
        </div>
      </div>

      <div className="border-t border-b border-[#d8d7dc]">
        {/* <div className="flex items-center justify-between py-4 border-b border-gray-200 px-4">
          <div className="flex items-center gap-2 text-sm font-semibold text-gray-800">
            Tasks ({filteredTasks.length})
          </div>
          <span className="text-gray-800 font-semibold text-sm">
            All Completed
          </span>
        </div> */}
        <ul className="divide-y border-b border-[#d8d7dc]">
          <li
            className="flex justify-between items-center px-4 py-3 hover:bg-gray-50 cursor-pointer"
            onClick={() => handleMyTask()}
          >
            <div className="flex-1 min-w-0">
              <div className="flex">
                <div>
                  <svg
                    className="w-6 h-6"
                    focusable="false"
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    fill="gray"
                  >
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4" />
                  </svg>
                </div>
                <div className="text-gray-600 ml-2 font-bold flex items-center">
                  My Tasks
                </div>
              </div>
            </div>

            <div className="ml-4 flex items-center gap-2">
              <div>
                <img
                  src={
                    (myTaskList[0] && myTaskList[0].assignTo?.avatarUrl) ||
                    `https://ui-avatars.com/api/?name=${encodeURIComponent(
                      (myTaskList[0] &&
                        myTaskList[0].assignTo?.preferredName) ||
                        user?.preferredName
                    )}`
                  }
                  alt={
                    (myTaskList[0] && myTaskList[0].assignTo?.preferredName) ||
                    "User"
                  }
                  className="w-8 h-8 rounded-full mr-1 object-cover !font-bold"
                />
              </div>
              <div>
                {numMyInComplete === 0 ? (
                  <span className="text-green-600 font-semibold">
                    All Completed
                  </span>
                ) : (
                  <span className="font-semibold">
                    {numMyInComplete} &nbsp; incomplete
                  </span>
                )}
              </div>
            </div>
          </li>
          <li
            className="flex justify-between items-center px-4 py-3 hover:bg-gray-50 cursor-pointer"
            onClick={() => handleAssignedMyTask()}
          >
            <div className="flex-1 min-w-0">
              <div className="flex">
                <div>
                  <svg
                    className="w-6 h-6"
                    focusable="false"
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    fill="gray"
                  >
                    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3m-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3m0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5m8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5" />
                  </svg>
                </div>
                <div className="text-gray-600 ml-2 font-bold flex items-center">
                  Assigned Tasks
                </div>
              </div>
            </div>

            <div className="ml-4 flex items-center gap-2">
              <div className="flex">
                {myAsignedTaskList.length > 0 &&
                  myAsignedTaskList.map((task, index) => (
                    <img
                      key={index}
                      src={
                        task.assignTo?.avatarUrl ||
                        `https://ui-avatars.com/api/?name=${encodeURIComponent(
                          task.assignTo?.preferredName || "User"
                        )}`
                      }
                      alt={task.assignTo?.preferredName || "User"}
                      className="w-8 h-8 rounded-full mr-1 object-cover !font-bold"
                    />
                  ))}
              </div>
              <div>
                {numAssignInComplete === 0 ? (
                  <span className="text-green-600 font-semibold">
                    All Completed
                  </span>
                ) : (
                  <span className="font-semibold">
                    {numAssignInComplete} &nbsp; incomplete
                  </span>
                )}
              </div>
            </div>
          </li>
        </ul>

        {filteredTasks.length === 0 ? (
          <div className="mt-12 text-center text-xl text-gray-600">
            No Tasks found!
          </div>
        ) : (
          <ul className="divide-y divide-[#d8d7dc] max-h-[70vh] overflow-y-auto">
            {filteredTasks?.map((task) => (
              <li
                key={task._id}
                className="flex justify-between items-center px-4 py-3 hover:bg-gray-50"
              >
                {/* User Avatar */}
                <div className="w-1/2 flex">
                  <img
                    src={
                      task.assignTo?.avatarUrl ||
                      `https://ui-avatars.com/api/?name=${encodeURIComponent(
                        task.assignTo?.preferredName || "User"
                      )}`
                    }
                    alt={task.assignTo?.preferredName || "User"}
                    className="w-10 h-10 rounded-full mr-4 object-cover"
                  />

                  <div className="w-full">
                    <p className="text-sm font-semibold text-gray-900 truncate">
                      {task.title}
                    </p>
                    <p className="text-sm text-gray-500 truncate">
                      {task.notes}
                    </p>
                  </div>
                </div>

                <div className="w-[25%] ml-4 flex justify-start items-center gap-2">
                  <p className="text-xs text-gray-400 mt-1">
                    <span
                      className={`${
                        new Date() > new Date(task.dueDate) && !task.completed
                          ? "text-red-500"
                          : ""
                      } mr-2`}
                    >
                      Due: {formatDate(task.dueDate)}
                    </span>
                    | Assigned to:{" "}
                    <span className="font-medium text-gray-700">
                      {task.assignTo?.preferredName || "Unassigned"}
                    </span>
                  </p>
                </div>

                <div className="ml-4 flex items-center gap-2">
                  {task.completed ? (
                    <span className="text-green-600 font-semibold pr-5">
                      Completed
                    </span>
                  ) : (
                    <span className="text-red-600 font-semibold pr-5">
                      Pending
                    </span>
                  )}

                  {/* Edit button */}
                  <button
                    onClick={() => handleEditTask(task)}
                    className="p-1 rounded hover:bg-gray-200"
                    title="Edit Task"
                  >
                    <Edit2 size={12} />
                  </button>

                  {/* Delete button */}
                  <button
                    onClick={() => handleDeleteTask(task._id)}
                    className="p-1 rounded hover:bg-gray-200"
                    title="Delete Task"
                  >
                    <Trash2 size={12} />
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>

      <AddTaskModal
        getTaskList={getTaskList}
        isOpen={openTaskModal}
        onClose={handleModalClose}
        task={editingTask} // Pass task to modal for editing
      />

      <LocationWithMap
        isOpen={openMapDialog}
        onClose={() => setOpenMapDialog(false)}
      />
    </div>
  );
}
